export default __webpack_public_path__ + "static/media/Confetti.1804b6e4.svg";